import { get } from 'lodash';
export default function isExperimentEnabled(experiments, experiment, value) {
    if (!value) {
        // Petri specs are on at `true`, Conductor A/B releases at `B`.
        value = ['true', 'B'];
    }
    const values = Array.isArray(value) ? value : [value];
    return values.includes(get(experiments, experiment));
}
//# sourceMappingURL=is-experiment-enabled.js.map